import React, { useState } from 'react'
import { Typography, IconButton, makeStyles } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { useDispatch } from 'react-redux'
import { removeDocument } from 'src/lib/store'

interface DocumentItemProps {
  file: any
  setSelectedFiles: (prevState: any) => void
}

export const DocumentItem: React.FC<DocumentItemProps> = ({ file, setSelectedFiles }) => {
  const dispatch = useDispatch()
  const [isFadingOut, setIsFadingOut] = useState(false)
  const classes = useStyles()

  
  const removeFile = (fileName: string) => {
    dispatch(removeDocument(fileName))
    setSelectedFiles((prevState: any) => prevState.filter((doc: any) => doc.name !== fileName))
    setIsFadingOut(false)
  }
  
  const fadeOut = () => {
    setIsFadingOut(true)
    removeFile(file.name)
  }

  return (
    <div style={{ height: 35 }}>
      <Typography variant="body2" style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className={isFadingOut ? classes.itemFadeOut : classes.item}>
        <IconButton aria-label="delete" className="ml-0" onClick={() => fadeOut()}>
          <DeleteIcon style={{ color: '#f27020' }} />
        </IconButton>
        {file.name}
      </Typography>
      <br />
    </div>
  )
}

const useStyles = makeStyles({
  item: {
    textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden',
    animation: 'fadein .3s linear forwards',
    WebkitAnimation: 'fadein .3s linear forwards'
  },
  itemFadeOut: {
    animation: 'fadeout .3s linear forwards',
    WebkitAnimation: 'fadeout .3s linear forwards'
  }
})